module.exports = __webpack_public_path__ + "static/media/pegaso-new.7d502edf.png";